import { useCompanyInfo } from "@/api/services/main/company";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { CompanyDetailContent } from "@/features/company/components/company-detail/CompanyDetailContent";
import { useValidateId } from "@/hooks/useValidateId";
import { useSyncMeOrgName } from "@/hooks/useSyncMeOrgName";
import { AppRoutes } from "@/routes/config";

const CompanyDetailPage = () => {
  const queryResult = useCompanyInfo();
  const { data, isLoading } = queryResult;
  useValidateId("companyId", AppRoutes.companyList, queryResult);

  // 連携同期で企業名が変わったら、詳細の値をヘッダー (useMe) にも反映する (自社閲覧時のみ)。
  useSyncMeOrgName({ type: "company", id: data?.data?.id, name: data?.data?.companyName });

  if (!data || isLoading) return <LoadingPage />;

  return <CompanyDetailContent defaultValues={data.data} />;
};

export default CompanyDetailPage;
